import { Box, Grid } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { PoolFormattedMessage } from '@synergy/components-next';
import { PoolFormikPasswordField } from '@synergy/components-next';
import { ReactElement, useEffect } from 'react';
import { fields } from '@synergy/utils';
import { useFormikContext } from 'formik';

import { ChangePasswordFormValues } from './models/change-password-form-values';
import { changePasswordSelector } from '../../../store/change-password-selectors';
import { useAppSelector } from '../../../../store/store';

export const fieldNames = fields<ChangePasswordFormValues>();

export const ChangePasswordContent = (): ReactElement => {
    const { hasError } = useAppSelector(changePasswordSelector);
    const formik = useFormikContext<ChangePasswordFormValues>();

    useEffect(() => {
        if (hasError) {
            formik.setFieldError(fieldNames.currentPassword, 'app.error.passwordWrong');
        }
        // We ignore formik as a dependency, because it will change with "setFieldError" and cause infinite updates
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasError]);

    return (
        <Grid container={true} spacing={2}>
            <Grid item={true} xs={12}>
                <Box sx={{ mb: { xs: 4, sm: 3 }, textAlign: 'center' }}>
                    <PoolFormattedMessage id="app.changePassword.hint" />
                </Box>
            </Grid>
            <Grid item={true} xs={12}>
                <PoolFormikPasswordField
                    name={fieldNames.currentPassword}
                    label={<FormattedMessage id="app.changePassword.currentPassword" />}
                    required={true}
                    fullWidth={true}
                />
            </Grid>
            <Grid item={true} xs={12}>
                <PoolFormikPasswordField
                    name={fieldNames.newPassword}
                    label={<FormattedMessage id="app.changePassword.newPassword" />}
                    required={true}
                    fullWidth={true}
                />
            </Grid>
            <Grid item={true} xs={12}>
                <PoolFormikPasswordField
                    name={fieldNames.newPasswordConfirmation}
                    label={<FormattedMessage id="app.changePassword.newPasswordConfirm" />}
                    required={true}
                    fullWidth={true}
                />
            </Grid>
        </Grid>
    );
};
